<template>
  <ul class="awards-list list-reset">
    <li
      v-for="award in formattedAwards"
      :key="award.id"
      class="awards-list__item"
    >
      <icon-component
        v-if="iconMap[award.status.toLowerCase()]"
        :name="iconMap[award.status.toLowerCase()]"
        class="awards-list__icon"
      />
      <span v-else class="awards-list__icon-placeholder" />
      <div>
        <p class="awards-list__name">{{ award.name }}</p>
        <span class="awards-list__status">
          {{ award.status }},
        </span> {{ award.year }}
        <br v-if="award.isPLC">
        {{ award.category }}
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AwardsList',
  props: {
    awards: {
      type: Array,
      required: true,
    },
    limit: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      iconMap: {
        winner: 'badge-award-winner',
        finalist: 'badge-award-finalist',
        completed: 'badge-patient-leader-certification',
      },
    };
  },
  computed: {
    formattedAwards() {
      let formattedAwards = [...this.awards]
        .filter((a) => a.status !== 'enrolled')
        .map(this.parseDates)
        .sort(this.sortByDate)
        .map((a) => ({
          id: a.id,
          isPLC: this.awardIsPLC(a),
          name: a.award.name,
          status: this.formatTitle(a.status),
          year: (this.awardIsPLC(a) ? this.getYear(a.earnedAt) : a.award.year),
          category: this.awardIsPLC(a) ? 'SocialHealthNetwork.com' : 'Social Health Awards',
        }));

      formattedAwards = this.putCertFirst(formattedAwards);

      if (this.limit > 0) return formattedAwards.slice(0, this.limit);

      return formattedAwards;
    },
  },
  methods: {
    putCertFirst(awards) {
      return [
        ...awards.filter((a) => this.awardIsPLC(a)),
        ...awards.filter((a) => !this.awardIsPLC(a)),
      ];
    },
    parseDates(a) {
      const award = { ...a };
      award.earnedAt = Date.parse(award.earnedAt);
      award.yearAsDate = Date.parse(award.award.year);
      return award;
    },
    formatTitle(word) {
      if (!word) return '';
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    },
    getYear(date) {
      if (!date) return '';
      const d = new Date(date);

      const options = {
        year: 'numeric',
      };

      return d.toLocaleString('en-US', options);
    },
    awardIsPLC(award) {
      const certName = 'Patient Leader Certification';
      return award.isPLC
        || award.name === certName
        || award.award?.name === certName;
    },
    sortByDate(a, b) {
      // It's possible for earnedAt to disagree with year on an award.
      // We should sort by year and then fall back to earnedAt if it's
      // not present or to break a tie.
      const aDate = a.yearAsDate || a.earnedAt;
      const bDate = b.yearAsDate || b.earnedAt;
      let result = bDate - aDate;

      if (result === 0) {
        result = b.earnedAt - a.earnedAt;
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_awards-list';
</style>
